import { PaginationQueryObject, QueryConfig } from "./Queries";
import {
  CreateLocationInput,
  Location,
  UpdateLocationInput,
} from "../../routeComponents/Locations/Location";

export const locationDetailsQuery = (id: string): QueryConfig => {
  const query = `query getLocation($id: String!) {
            location(id: $id) {
                id
                name
                address {
                    address1
                    address2
                    city
                    subdivision: stateProvince
                    postalCode
                    nation: country
                }
                isPhysicalLocation
                shortCode
                ein
                sicCode
                establishmentType
                industryDescription
                naicsCode
                lineage
                locationStatus
                parentLocation { id, locationStatus }
                viewerCanActivateLocation
                viewerCanAddChildLocation
                viewerCanArchiveLocation
                viewerCanInactivateLocation
                viewerCanManageLocation
                viewerCanMoveLocation
            }
        }`;
  return {
    query: query,
    variables: {
      id,
    },
  };
};

export const addLocationMutation = (
  customerId: string,
  newLocation: Location
): QueryConfig => {
  const query = `mutation addLocation($input: LocationCreateInput!) { 
            createLocation(input: $input) { id }
        }`;
  return {
    query: query,
    variables: {
      input: {
        customerID: customerId,
        name: newLocation.name,
        shortCode: newLocation.shortCode,
        industryDescription: newLocation.industryDescription,
        parentID: newLocation.parentLocation?.id,
        locationStatus: newLocation.locationStatus,
        establishmentType:
          typeof newLocation?.establishmentType === "string"
            ? newLocation?.establishmentType
            : newLocation?.establishmentType?.id,
        address1: newLocation.address.address1,
        address2: newLocation.address.address2,
        city: newLocation.address.city,
        postalCode: newLocation.address.postalCode,
        sicCode: newLocation.sicCode,
        naicsCode: newLocation.naicsCode,
        ein: newLocation.ein,
        stateProvince: newLocation.address.subdivision?.name,
        country: newLocation.address.nation?.countryCode,
      },
    },
  };
};

export const updateLocationMutation = (
  updatedLocation: Location,
  isPhysicalLocation?: boolean
): QueryConfig => {
  const query = `mutation updateLocation($input: LocationUpdateInput!) { 
            updateLocation(input: $input) { id }
        }`;
  return {
    query: query,
    variables: {
      input: {
        id: updatedLocation.id,
        name: updatedLocation.name,
        shortCode: updatedLocation?.shortCode,
        industryDescription: updatedLocation?.industryDescription,
        establishmentType:
          typeof updatedLocation.establishmentType === "string"
            ? updatedLocation?.establishmentType
            : updatedLocation?.establishmentType?.id,
        sicCode: updatedLocation?.sicCode,
        naicsCode: updatedLocation?.naicsCode,
        ein: updatedLocation?.ein,
        locationStatus: updatedLocation.locationStatus,
        address1: updatedLocation.address?.address1,
        address2: updatedLocation.address?.address2,
        city: updatedLocation.address?.city,
        postalCode: updatedLocation.address?.postalCode,
        stateProvince: isPhysicalLocation
          ? updatedLocation.address?.subdivision?.name
          : null,
        country: isPhysicalLocation
          ? updatedLocation.address?.nation?.countryCode
          : null,
      },
    },
  };
};

export const moveLocationMutation = (
  locationId: string,
  newParentLocationId: string
): QueryConfig => {
  const query = `mutation moveLocation($locationId: String!, $newParentLocationId: String!) { 
            moveLocation(locationId: $locationId, newParentLocationId: $newParentLocationId) { id }
        }`;
  return {
    query: query,
    variables: {
      locationId,
      newParentLocationId,
    },
  };
};

export const countryListQuery = (
  filter: any,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getCountryList($filter: CountryEnumFilter, $pagination: PaginationInput) {
            countryList(filter: $filter, paginationInput: $pagination) {
                items {
                    countryCode,
                    name,
                    subdivisions: subdivisions { countryCode, name, subdivisionCode }
                },
                #pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
            }
        }`;
  return {
    query: query,
    variables: {
      filter: filter,
      pagination: pagination,
    },
  };
};

export const locationsUserPermissions = (
  userId: String,
  customerId: String
): QueryConfig => {
  const query = `query locationsUserPermissions($userId: ID!, $customerId: ID!) {
            locations_user(userId: $userId, customerId: $customerId) {
                canManageLocations
                canManageOrgHierarchies
            }
        }`;
  return {
    query: query,
    variables: {
      userId,
      customerId,
    },
  };
};

export const createLocationMutation = (
  input: CreateLocationInput
): QueryConfig => {
  const query = `
  mutation createLocation($input: LocationCreateInput!){
    createLocation(input: $input){
      id
    }
  }`;
  return {
    query: query,
    variables: {
      input,
    },
  };
};

export const locationUpdateMutation = (
  input: UpdateLocationInput
): QueryConfig => {
  const query = `
  mutation updateLocation($input: LocationUpdateInput!){
    updateLocation(input: $input){
      id
    }
  }`;
  return {
    query: query,
    variables: {
      input,
    },
  };
};
